import React from 'react';
import PropTypes from 'prop-types';

export const Plus = ({ width, height, ...props }) => (
  <svg
    data-icon='plus'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M11 13H5v-2h6V5h2v6h6v2h-6v6h-2v-6Z'
    />
  </svg>
);

Plus.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Plus.defaultProps = {
  width: 24,
  height: 24,
};
